import { useEffect, useState } from "react";
import { Stack, useTheme } from "@mui/system";
import { IconButton, Modal, Slide, Typography } from "@mui/material";
import { toLocaleDateTimeString, formatSize } from "@utils";
import { Close as CloseIcon } from "@mui/icons-material";
import { ValidWalkthrough } from "@utils/useManageAttachments";

export const WalkthroughPreviewModal = ({
  attachment,
  onClose,
}: {
  attachment: ValidWalkthrough;
  onClose: () => void;
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const theme = useTheme();
  const [url, setUrl] = useState<string>("");

  useEffect(() => {
    setPreviewOpen(true);

    if (attachment.state !== "completed") {
      const newUrl = URL.createObjectURL(attachment.file);
      setUrl(newUrl);
      return () => URL.revokeObjectURL(newUrl);
    } else {
      setUrl(attachment.url);
    }
  }, [attachment]);

  const createdAtText =
    attachment.state === "completed" &&
    `Uploaded: ${toLocaleDateTimeString(attachment.createdAt)}`;

  const infoText = [formatSize(attachment.size || 0), createdAtText]
    .filter(Boolean)
    .join(" • ");

  return (
    <Modal open={previewOpen} onClose={() => setPreviewOpen(false)}>
      <Slide in={previewOpen} direction="up">
        <Stack padding={2} height={1} bgcolor={theme.palette.grey[900]}>
          <Stack direction="row" color="white" justifyContent="space-between">
            <Stack>
              <Typography>{attachment.name}</Typography>
              <Typography>{infoText}</Typography>
            </Stack>
            <IconButton
              onClick={() => {
                setPreviewOpen(false);
                onClose();
              }}
              color="inherit"
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack
            justifyContent="center"
            alignItems="center"
            height={1}
            overflow="auto"
          >
            <video
              style={{
                width: "100%",
                height: "100%",
                maxHeight: "100%",
              }}
              controls
              autoPlay={true}
              data-testid="video-player"
              preload="auto"
              src={url}
            >
              {/* <source src={url} type="video/mp4" /> */}
            </video>
          </Stack>
        </Stack>
      </Slide>
    </Modal>
  );
};
